import {
  paymentStatuses,
  refundStatuses,
  shipmentStatuses,
  shippingLabelTypes,
  trackingStatuses,
} from '@reveni-io/reveni-ui'

export const scenarioReturnedValues = {
  yes: 'yes',
  no: 'no',
}

export const scenarioReturnedOptions = [
  { value: scenarioReturnedValues.yes, label: 'Sí' },
  { value: scenarioReturnedValues.no, label: 'No' },
]

const newScenarioItem = { returned: false, status: trackingStatuses.processing }

const defaultScenarioItems = [
  { returned: true, status: trackingStatuses.returnRequested },
  { returned: false, status: trackingStatuses.delivered },
  { returned: false, status: trackingStatuses.delivered },
]

export const scenarioLineItemReferences = {
  shipmentId: 'custom-scenario-shipment',
  returnId: 'custom-scenario-return',
}

const newScenarioShipment = { type: shippingLabelTypes.shipment, status: shipmentStatuses.ready }

const defaultScenarioShipments = [
  { type: shippingLabelTypes.shipment, status: shipmentStatuses.delivered },
  { type: shippingLabelTypes.return, status: shipmentStatuses.ready },
]

export const scenarioOperationResults = {
  refundCompleted: 'refundCompleted',
  refundPending: 'refundPending',
  refundDeclined: 'refundDeclined',
  paymentCompleted: 'paymentCompleted',
  paymentPending: 'paymentPending',
}

export const scenarioOperationResultStatuses = {
  [scenarioOperationResults.refundCompleted]: { refund_status: refundStatuses.completed, payment_status: null },
  [scenarioOperationResults.refundPending]: { refund_status: refundStatuses.pending, payment_status: null },
  [scenarioOperationResults.refundDeclined]: { refund_status: refundStatuses.declined, payment_status: null },
  [scenarioOperationResults.paymentCompleted]: { refund_status: null, payment_status: paymentStatuses.completed },
  [scenarioOperationResults.paymentPending]: { refund_status: null, payment_status: paymentStatuses.pending },
}

export const scenarioFallbackReturnAmount = '50.00'

const newScenarioReturnRequest = { operationResult: scenarioOperationResults.refundPending }

export const scenarioCollections = {
  items: {
    storageKeyPrefix: 'trackingPageCustomScenario',
    newEntry: newScenarioItem,
    defaultEntries: defaultScenarioItems,
  },
  shipments: {
    storageKeyPrefix: 'trackingPageCustomScenarioShipments',
    newEntry: newScenarioShipment,
    defaultEntries: defaultScenarioShipments,
  },
  returnRequests: {
    storageKeyPrefix: 'trackingPageCustomScenarioReturnRequests',
    newEntry: newScenarioReturnRequest,
    defaultEntries: [newScenarioReturnRequest],
  },
}
